import { render } from 'preact'
import React from 'preact/compat'

import Router from './router'

import 'reset-css/sass/_reset.scss'
import 'Styles/_default.scss'

render(<Router />, document.querySelector('#root'))
